import type { AnchorHTMLAttributes, ReactNode } from 'react';

import type { Props as StarsLinkProps } from '../StarsLink/StarsLink';
import StarsLink from '../StarsLink/StarsLink';

export const translatedLink =
  (props: React.DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>) =>
  (msg: ReactNode) =>
    <StarsLink {...(props as StarsLinkProps)}>{msg}</StarsLink>;
